import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "dropdown", "dropdownMenu", "dropdownLabel"]
  static values = { default: String }

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    const defaultTab = this.defaultValue || this.tabTargets[0]?.dataset.tab
    if (defaultTab) {
      this.showTab(defaultTab)
    }
  }

  select(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.showTab(tab)
    this.closeDropdown()
  }

  toggleDropdown(event) {
    event.stopPropagation()
    if (this.hasDropdownMenuTarget) {
      const isHidden = this.dropdownMenuTarget.classList.contains("hidden")
      if (isHidden) {
        this.dropdownMenuTarget.classList.remove("hidden")
        document.addEventListener("click", this.boundClickOutside)
      } else {
        this.closeDropdown()
      }
    }
  }

  closeDropdown() {
    if (this.hasDropdownMenuTarget) {
      this.dropdownMenuTarget.classList.add("hidden")
      document.removeEventListener("click", this.boundClickOutside)
    }
  }

  clickOutside(event) {
    if (this.hasDropdownTarget && !this.dropdownTarget.contains(event.target)) {
      this.closeDropdown()
    }
  }

  showTab(tabName) {
    // Update tab states
    this.tabTargets.forEach(tab => {
      const isDarkStyle = tab.classList.contains("rounded-md")

      if (tab.dataset.tab === tabName) {
        if (isDarkStyle) {
          tab.classList.remove("text-beige-300", "hover:text-white", "hover:bg-beige-700/50")
          tab.classList.add("text-white", "bg-beige-700")
        } else {
          tab.classList.add("tab-active")
          tab.classList.remove("tab-inactive")
        }
      } else {
        if (isDarkStyle) {
          tab.classList.remove("text-white", "bg-beige-700")
          tab.classList.add("text-beige-300", "hover:text-white", "hover:bg-beige-700/50")
        } else {
          tab.classList.remove("tab-active")
          tab.classList.add("tab-inactive")
        }
      }
    })

    // Update panel visibility
    this.panelTargets.forEach(panel => {
      if (panel.dataset.tab === tabName) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })

    // Update dropdown label if present
    if (this.hasDropdownLabelTarget) {
      const activeTab = this.tabTargets.find(tab => tab.dataset.tab === tabName)
      if (activeTab) {
        this.dropdownLabelTarget.textContent = activeTab.textContent.trim()
      }
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
  }
}
